export enum CONTRACT_STATUS {
	WAITING_FOR_REVIEW = 'WAITING_FOR_REVIEW',
	IN_REVIEW = 'IN_REVIEW',
	REJECTED = 'REJECTED',
	APPROVED = 'APPROVED',
	SIGNED = 'SIGNED',
}